import {SealCheck,ArrowLeft} from '@phosphor-icons/react';
import {PROGRAM_FEATURES} from './program-subscription.js';
import './program-subscription.css';

export function PlanBadge({subscription}) {
  if(!subscription)return null;
  return <span className="n9-plan-badge" title={subscription.isTrial?'نسخة PRO تدريبية':'خطة المكتب'}><SealCheck size={14}/><b dir="ltr">{subscription.name}</b>{subscription.isTrial&&<span>تجريبية</span>}</span>;
}
export function ProgramFeatures({header}) {
  return <div dir="rtl" className="n9-program-features">{header}<main className="n9-subscription">
    <header className="n9-subscription-heading"><div><small>N9 LAW SYSTEM</small><h1>مزايا البرنامج</h1><PlanBadge subscription={{name:'PRO',isTrial:true}}/></div><a href="/guide">التجربة العملية <ArrowLeft size={18}/></a></header>
    <p>النسخة التدريبية تقدم أنظمة PRO. صلاحيات كل حساب وتفعيلات المحركات تحدد ما يتاح له داخل التجربة.</p>
    <div className="n9-feature-grid">{PROGRAM_FEATURES.map(group=><section key={group.title}><h2>{group.title}</h2><ul>{group.features.map(feature=><li key={feature}>{feature}</li>)}</ul></section>)}</div>
    <section className="n9-subscription-future"><h2>قادمًا: Ultra</h2><p>الذكاء الاصطناعي، وفروع المكتب، وإدارة المكاتب المتعددة. هذه المزايا غير مفعلة حاليًا.</p></section>
    <footer>تُضاف أنظمة ومزايا جديدة تباعًا. قد تترتب رسوم إضافية على المحركات عند الاستخدام العالي.</footer>
  </main></div>;
}
